import { useEffect, useState } from "react";
import { Tree } from "primereact/tree";
import { Image } from "primereact/image";
import { Tooltip } from "primereact/tooltip";

import {
  labelArchive,
  labelArchivio,
  labelCodes,
  labelCodex,
  labelFonteUsed,
  labelFonti,
  labelFontiUsed,
  labelNoSource,
  labelPrivate,
  labelPrivates,
  labelSourceDeleteTree,
  labelSourceUpdate,
  labelToneOfVoce,
  labelTooltipPdf,
} from "_constants";
import { DetailAnswer, ProjectSource } from "interfaces";
import toneVoiceIcon from "assets/icons/icon_tone_of_voice.svg";
import { getFileIconByFileType, getTypeToneOfVoice } from "utils";
import { ReactMarkdownAI } from "components/shared";

export const BodyModalDetailResponse = ({
  detailResp,
}: {
  detailResp: DetailAnswer;
}) => {
  const [sourceCount, setSourceCount] = useState(0);
  const selectedKey = "";
  const [nodes, setNodes] = useState<any[]>([]);

  useEffect(() => {
    if (detailResp) {
      setSourceCount(
        detailResp!.sourcesList?.length +
          detailResp!.privateSourcesList?.length +
          detailResp!.codesList?.length
      );
      const data = [
        ...(detailResp?.codesList?.length
          ? [
              {
                key: "0",
                label: labelCodes,
                children: detailResp?.codesList.map((code: ProjectSource) => ({
                  key: code?.id,
                  label: code.name,
                  type: labelCodex,
                  stateUpdate: code.stateUpdate,
                })),
              },
            ]
          : []),
        ...(detailResp?.sourcesList?.length
          ? [
              {
                key: "1",
                label: labelArchivio,
                children: detailResp?.sourcesList.map(
                  (source: ProjectSource) => ({
                    key: source?.id,
                    label: source.name,
                    fileType: source.fileType,
                    type: labelArchive,
                    stateUpdate: source.stateUpdate,
                  })
                ),
              },
            ]
          : []),
        ...(detailResp?.privateSourcesList?.length
          ? [
              {
                key: "2",
                label: labelPrivate,
                children: detailResp?.privateSourcesList.map(
                  (privateSource: ProjectSource) => ({
                    key: privateSource?.id,
                    label: privateSource.name,
                    fileType: privateSource.fileType,
                    type: labelPrivates,
                    stateUpdate: privateSource.stateUpdate,
                  })
                ),
              },
            ]
          : []),
      ];
      setNodes(data);
    }
  }, [detailResp]);

  const nodeTemplate = (node: any) => {
    const isParentNode = !!node.children;
    const isFileType = node.fileType;
    const roundSourceLabel = () => {
      if (node.label === "Codici") {
        return <span className="round-source margin-right-5"></span>;
      } else if (node.label === "Archivio") {
        return <span className="round-source margin-right-5 archive"></span>;
      } else if (node.label === "Privata") {
        return <span className="round-source margin-right-5 private"></span>;
      }
      return null;
    };

    return (
      <div className="flex-container align-center relative tree-source overflow-hidden">
        {isParentNode && roundSourceLabel()}
        {!isParentNode && isFileType && (
          <Image
            src={getFileIconByFileType(node.fileType)}
            alt={labelTooltipPdf}
          />
        )}
        <Tooltip
          target={`.tree-detail-label`}
          position="bottom"
          mouseTrack
          mouseTrackLeft={10}
        />
        <div className="flex-container column gap-2 overflow-hidden">
          <span
            className={`margin-left-7 ellipsis tree-detail-label  ${
              isParentNode ? "font-weight-700" : ""
            }
            ${node.stateUpdate === "ELIMINATO" ? "line-through" : ""}`}
            data-pr-tooltip={!isParentNode ? node.label : ""}
          >
            {node.label}
          </span>
          <span className="margin-left-7 text-sm-blue">
            {node.stateUpdate === "ELIMINATO"
              ? labelSourceDeleteTree
              : node.stateUpdate === "DEPRECATO"
              ? labelSourceUpdate
              : ""}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="height-100 d-grid auto-fr overflow-hidden">
      <div className="container-source-response width-px-300">
        <div className="header">
          <span className="text-title font-weight-700">{labelToneOfVoce}</span>
          <div className="flex-container gap-4 margin-top-8">
            <Image src={toneVoiceIcon} alt="" />
            <span className="text-base-regular  font-weight-500 italic">
              {getTypeToneOfVoice(detailResp?.toneOfVoice ?? 0)}
            </span>
          </div>
        </div>
        <div className="padd-18 flex-container column gap-8">
          <span className="text-title font-weight-700">
            {labelFonti.toUpperCase()}
          </span>
          <span
            className={`text-base-regular font-weight-500 ${
              sourceCount === 0 ? "italic" : ""
            }`}
          >
            {" "}
            {`${
              sourceCount === 0
                ? labelNoSource
                : sourceCount === 1
                ? `${sourceCount} ${labelFonteUsed}`
                : `${sourceCount} ${labelFontiUsed}`
            }`}
          </span>
        </div>
        {nodes.length > 0 && (
          <div className="source-tree no-bar">
            <Tree
              value={nodes}
              selectionMode="single"
              selectionKeys={selectedKey}
              className="width-100 tree-detail"
              nodeTemplate={nodeTemplate}
            />
          </div>
        )}
      </div>
      <div className="padd-18 overflow-auto">
        <ReactMarkdownAI
          message={detailResp.message?.replace(/\n/g, "  \n  ")}
        />
      </div>
    </div>
  );
};
